<template>
  <form @submit.prevent class="cursor-copy" ref="listRowBoundary" @click="copyField()">
    <div class="flex ">
      <div class="w-full">
        <label class=" text-gray-800 w-full p-1.5 font-medium tracking-wide flex items-center justify-between" for="">
          <slot name="label"></slot>
        </label>
      </div>
    </div>
        <base-tool-tip
          v-if="visibleCopiedPopover"
          :xPosition="xPosition"
          :yPosition="yPosition"
        >
          <template #title>
            Copied!
          </template>
        </base-tool-tip>
  </form>
</template>
  
<script setup>
import { defineEmits, defineProps, ref } from 'vue';
import { useClipboard } from '@vueuse/core'

  const emit = defineEmits(['close'])
  const props = defineProps({
    active: Boolean,
    name: String,
    canCopy: Boolean,
    index: Number,
    startingIndex: Number,
    endingIndex: Number
  })

const source = ref(props.name)
const { text, copy, copied, isSupported } = useClipboard({ source })


const listRowBoundary = ref(null)
const visibleCopiedPopover = ref(false)
const xPosition = ref(null)
const yPosition = ref(null)


function copyField() {
  // console.log('copyValue', source.value)
  copy(source.value)
  showCopiedPopover(1500)
}

function showCopiedPopover(mS) {
  xPosition.value = listRowBoundary.value.getBoundingClientRect().left
  yPosition.value = listRowBoundary.value.getBoundingClientRect().bottom
  visibleCopiedPopover.value = true
  setTimeout(() => {
    visibleCopiedPopover.value = false
  }, mS)
}

</script>